import { render, staticRenderFns } from "./InvestmentDetailsTab.vue?vue&type=template&id=74f939bd&scoped=true"
import script from "./InvestmentDetailsTab.vue?vue&type=script&lang=js"
export * from "./InvestmentDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./InvestmentDetailsTab.vue?vue&type=style&index=0&id=74f939bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f939bd",
  null
  
)

export default component.exports